import { render, staticRenderFns } from "./FAQDetails.vue?vue&type=template&id=62642e49&scoped=true&"
import script from "./FAQDetails.vue?vue&type=script&lang=js&"
export * from "./FAQDetails.vue?vue&type=script&lang=js&"
import style0 from "./FAQDetails.vue?vue&type=style&index=0&id=62642e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62642e49",
  null
  
)

export default component.exports